import React, { useCallback, useEffect, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import DrawerModal from '../../components/shared/DrawerModal';
import styles from './UpdateVehicleFleetModal.styles';
import {
  updateCarIfNeeded,
  selectSelectedCar,
} from '../../redux/store/userData/cars';
import { getIsVisibleModal, closeModal } from '../../redux/store/ui/common';
import { selectToken } from '../../redux/store/userData/user';
import CarEditorFleetSelector from './CarEditorFleetSelector';
import { useIntl } from 'react-intl';
import {
  selectFleets,
  fetchFleetsIfNeeded,
} from '../../redux/store/appData/fleets';

export const updateVehicleFleetModal = 'updateVehicleFleetModal';

const UpdateFleetModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const selectedCar = useSelector(selectSelectedCar);
  const fleets = useSelector(selectFleets) as any;
  const [fleetId, setFleetId] = useState(selectedCar?.profileId);
  const visibleModal = useSelector(getIsVisibleModal(updateVehicleFleetModal));
  const currentFleet = selectedCar?.fleetId;

  const handleUpdateFleet = (
    value: React.SetStateAction<string | undefined>
  ) => {
    setFleetId(value);
  };

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    batch(() => {
      dispatch(
        updateCarIfNeeded(token, selectedCar?.id!, {
          fleetId: fleetId,
        })
      );
    });
    dispatch(closeModal(updateVehicleFleetModal));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal(updateVehicleFleetModal));
  };

  const loadFleets = useCallback(async () => {
    dispatch(fetchFleetsIfNeeded());
  }, []);

  useEffect(() => {
    if (visibleModal && !fleets) {
      loadFleets();
    }
  }, [visibleModal]);

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal(updateVehicleFleetModal));
        }}
      >
        <div className="update-car-fleet-modal">
          <div className="fleet-selector-wrapper">
            <p className="label">Fleets</p>
            <CarEditorFleetSelector
              className="car-editor-fleet-selector"
              defaultValue={currentFleet}
              onSelect={handleUpdateFleet}
              loading={false}
            />
          </div>
          <Button
            className="submit-button"
            onClick={handleOnSubmit}
            disabled={currentFleet === fleetId}
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UpdateFleetModal;
